import { util } from 'pevueglobal'

const state = {
  settings: {},
  selectedPersonOption: '',
  person: {},
  extOrg: {}
}

// getters
const getters = {
  settings: state => state.settings,
  selectedPersonOption: state => state.selectedPersonOption,
  person: state => state.person,
  extOrg: state => state.extOrg
}

// actions
const actions = {
  getTexten: async ({ dispatch }) => {
    let textIDs = [
      4,
      4909,
      4910,
      4911,
      4912,
      4922,
      4923,
      4924,
      4925,
      4926,
      4927,
      4937,
      4939,
      4942,
      4963,
      5373,
      5374,
      5375,
      5376,
      5377,
      5378,
      5379,
      5384,
      7678,
      7679,
      7680,
      7681
    ]
    dispatch('gettranslations', textIDs, { root: true })
  },
  initSettings: async ({ commit }, profgroupID) => {
    const data = await util.getDataApi('public/PEapi_SPE620_ExtOrgAccountAanvragen', { profgroupID })
    commit('setSettings', data.ds.data0[0])

    const { createAccountSetting } = data.ds.data0[0]
    if (createAccountSetting !== 0) {
      commit('setSelectedPersonOption', createAccountSetting === 1 ? 'rdExcistingPerson' : 'rdNewPerson')
    }
  },
  createExtOrg: async ({ state, rootState, rootGetters }, { tblPersonID, profgroupID }) => {
    const { metainput, infoRequiredTable } = rootGetters['Metafields/GetSaveMetaData']({
      infoRequiredName: 'TblExternalOrganizationInfoRequired'
    })

    await util.getDataApi('public/PEapi_SPE620_EXTORG_AccountAanvragen', {
      tblPersonID,
      profgroupID,
      ...state.extOrg,
      ...state.person,
      metainput: metainput.map(({ fieldID, ...rest }) => ({ metaTableID: fieldID, ...rest })),
      infoRequiredTable,
      parameters: []
    })
    if (state.selectedPersonOption === 'rdExcistingPerson') {
      util.showVueMessageAfterRedirect(rootState.translation[5384], 'gritter-primary', true, '')
    } else if (state.selectedPersonOption === 'rdNewPerson') {
      util.showVueMessageAfterRedirect(rootState.translation[4963], 'gritter-primary', true, '')
    }

    const data = await util.getDataApi('public/PEapi_GetProfgroupLoginUrl', {
      SES_bergrpid: profgroupID
    })

    window.location = data.ds.data0[0].loginUrl
  }
}

// mutations
const mutations = {
  setSettings(state, settings) {
    state.settings = settings
  },
  setSelectedPersonOption(state, selectedPersonOption) {
    state.selectedPersonOption = selectedPersonOption
    state.person = {}
  },
  SET_EXT_ORG(state, value) {
    state.extOrg = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
